/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {AbstractResourceService} from '@irian-ro/abstract-resource';
import { HttpClient } from '@angular/common/http';
import {selectItemsFieldName} from './select-items-field-name';
import {SelectItemsManagementModel} from './select-items-management.model';
import {EnvironmentService} from "@irian-ro/util-environment";
import {Observable} from "rxjs";
import { SelectItemsVoModel } from "@well/common-libs/select-items/domain";

@Injectable({
  providedIn: 'root'
})
export class SelectItemsProviderResourceService extends AbstractResourceService<SelectItemsVoModel,
  SelectItemsManagementModel,
  any,
  any> {
  constructor(httpClient: HttpClient,
              private environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('selectItemsProviderUrl'),
      SelectItemsVoModel,
      SelectItemsManagementModel
    );
  }

  getSelectItemsFieldNames(): any[] {
    return selectItemsFieldName;
  }

  enable(uuid:string): Observable<any> {
    return this.httpClient?.post(`${this.url}/enable/${uuid}`, {headers: this.headers})
      .pipe(this.getDtoMapper());
  }
}
